export default __webpack_public_path__ + "static/media/direct_print_White.58afd00e.svg";